import React from "react";

const Header = () => {
  return (
    <div className="bg-lightest-blue o-70 tc br3 center ">
      <span className="f1 fw7 tracked-mega">House Points Tracker</span>
    </div>
  );
};

export default Header;
